//frontend/src/components/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Package, AlertTriangle } from 'lucide-react';

const NotFound = () => {
    return (
        <div className="min-h-[80vh] flex items-center justify-center bg-gray-50">
            <div className="max-w-lg w-full px-4">
                <div className="text-center">
                    <div className="flex justify-center mb-6">
                        <AlertTriangle className="h-24 w-24 text-[#dc2626] animate-pulse" />
                    </div>
                    
                    <h1 className="text-4xl font-bold text-gray-900 mb-4 font-['Crimson_Text']">
                        404
                    </h1>
                    
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6 font-['Crimson_Text']">
                        Page Not Found
                    </h2>
                    
                    <p className="text-gray-600 mb-8">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link 
                            to="/"
                            className="inline-flex items-center justify-center px-6 py-3 bg-[#dc2626] text-white rounded-lg hover:bg-[#dc2626]/90 transition-colors"
                        >
                            <Home className="w-5 h-5 mr-2" />
                            Return Home
                        </Link>
                        
                        <Link 
                            to="/shop"
                            className="inline-flex items-center justify-center px-6 py-3 border border-[#dc2626] text-[#dc2626] rounded-lg hover:bg-red-50 transition-colors"
                        >
                            <Package className="w-5 h-5 mr-2" />
                            Browse Shop
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;